import React from "react";
import "./LoaderLogo.css";

class LogoLoader extends React.Component {
  render() {
    return (
      <div className="loader-container">
        <div className="loader-content">
          <div className="name-group">
            <span className="name-first">Zubair</span>
            <span className="name-middle">Ali</span>
            <span className="name-last">Sandhu</span>
          </div>
          <div className="loader-line"></div>
          <span className="loader-role">Full Stack Developer</span>
        </div>
        <div className="loader-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    );
  }
}

export default LogoLoader;
